import Icon from "@components/ui/icon";
import { WIDE_TOAST_CONTAINER_ID } from "@components/toast";
import { IconX } from "@tabler/icons-react";
import { toast } from "react-toastify";
import { EXPORT_FORMAT_LABEL, type TExportFormat } from "../types";

// Full-width "we're generating" banner shown while the PDF export runs in
// the background. A react-toastify toast (in the wide-banner container) so
// positioning, stacking, dismissal, exit animation and aria-live come from
// the shared ToastContainer. Closing it only hides the notification.

const TOAST_ID = "pdf-export-generating";

// Strip toastify's default card chrome so the toast is just our purple bar.
const TOAST_CONTAINER_CLASS_NAME =
  "!tw-min-h-0 !tw-w-full !tw-rounded-lg !tw-bg-violet-700 !tw-p-0 !tw-shadow-sm tw-outline tw-outline-1 tw-outline-offset-0 tw-outline-blue-base/5 tw-mb-0";
const TOAST_BODY_CLASS_NAME = "!tw-m-0 !tw-py-3.5 !tw-pl-4 !tw-pr-0";

const PdfGeneratingToastContent = ({ format }: { format: TExportFormat }) => (
  <div className="tw-flex tw-w-full tw-items-center tw-gap-3">
    <Icon icon="ri-sparkling-2-fill" className="tw-shrink-0 tw-text-white" />
    <span className="tw-flex-1 tw-font-sans tw-text-sm tw-font-medium tw-text-violet-50">
      We&apos;re preparing your {EXPORT_FORMAT_LABEL[format]} export. It can
      take a moment. Keep working and we&apos;ll let you know once it&apos;s
      ready!
    </span>
  </div>
);

export const pdfGeneratingToast = (format: TExportFormat = "pdf") =>
  toast(<PdfGeneratingToastContent format={format} />, {
    containerId: WIDE_TOAST_CONTAINER_ID,
    toastId: TOAST_ID,
    icon: false,
    position: "bottom-center",
    autoClose: false,
    closeOnClick: false,
    className: TOAST_CONTAINER_CLASS_NAME,
    bodyClassName: TOAST_BODY_CLASS_NAME,
    closeButton: ({ closeToast }) => (
      <button
        type="button"
        aria-label="Dismiss PDF export notification"
        onClick={closeToast}
        className="tw-mr-4 tw-shrink-0 tw-cursor-pointer tw-self-center tw-rounded tw-text-white/80 hover:tw-text-white focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white"
      >
        <IconX className="tw-size-4 tw-text-white" />
      </button>
    ),
  });

export const dismissPdfGeneratingToast = () =>
  toast.dismiss({ id: TOAST_ID, containerId: WIDE_TOAST_CONTAINER_ID });
